module.exports = __webpack_public_path__ + "static/media/articles2.d5ef30eb.png";